import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App_Mapbox';
import './index.css';

import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';

document.title = "MAADEN CARTO";

const darkTheme = createTheme({
  typography: {
    fontFamily: "'Louguiya', Arial, sans-serif"
  },
  palette: {
    mode: 'dark',
    primary: { main: '#fff' },
    background: { default: '#181a20', paper: '#232634' },
    text: { primary: '#f4f6fa', secondary: '#bdbdbd' },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
